<template>
    <div class="match-detail">
      <!-- 顶部 -->
      <div class="top">
        <div class="bg-img">
          <img :src="filterImage(match.backgroundImage2,375,300,2)" />
        </div>
        <div class="nav-menu">
          <div class="item" @click="goList('standings')">
            <img src="@/assets/images/jifen.gif">
            <p>{{ $t('match.homeTabs.text_1') }}</p>
          </div>
          <div class="item" @click="goList('MatchSchedule')">
            <img src="@/assets/images/saichen.gif">
            <p>{{ $t('match.homeTabs.text_2') }}</p>
          </div>
          <div class="item" v-if="match.sportType === '橄榄球'" @click="goList('team-list')">
            <img src="@/assets/images/team_rank_icon.jpg">
            <p>{{ $t('match.homeTabs.text_3') }}</p>
          </div>
          <div class="item" @click="goList('player-list')" v-if="match.sportType == '足球' || match.sportType == '篮球' || match.sportType == '橄榄球'">
            <img src="@/assets/images/playerrank.png">
            <p>{{ $t('match.homeTabs.text_4') }}</p>
          </div>
          <div class="item" @click="goList('baseball-data')" v-else-if="match.sportType == '棒球' && match.showBaseballStats === 1">
            <img src="@/assets/images/playerrank.png">
            <p>{{ $t('match.homeTabs.text_4') }}</p>
          </div>
          <div class="item" @click="goList('match-ranking')" v-if="match.isBangSaiShi === 1 && championList.length > 0 && !jetlympic">
            <img src="@/assets/images/match_info.png">
            <p>{{ $t('match.homeTabs.text_5') }}</p>
          </div>
        </div>
      </div>

      <!-- 赛程状况 -->
      <div class="match-status" v-if="status.length > 0">
        <div class="card bot">
          <p>赛程实况 <span @click="goList('MatchSchedule')">更多</span></p>
        </div>
        <div v-if="status.length === 1">
          <div class="match-status-one" v-for="item in status" :key="item.id" @click="ateToPage(item)">
            <div class="team-class">
              <img :src="filterImage(item.homeTeam.badge, 104, 104)" >
              <span> {{ item.homeTeam.name }}</span>
            </div>
            <div class="vs">
              <div class="score">
                <span v-if="item.homeScore >= 0">{{ item.homeScore }}</span>
                <span style="margin: 0 10px;">一</span>
                <span v-if="item.awayScore >= 0">{{ item.awayScore }}</span>
              </div>
              <div :style="{ color: item.liveStatus.statusLabel == '视频录像' ? 'rgb(54, 154, 212)' : '' }" >{{ item.liveStatus.statusLabel }}</div>
            </div>
            <div class="team-class">
              <img :src="filterImage(item.awayTeam.badge, 104, 104)" >
              <span>{{ item.awayTeam.name }}</span>
            </div>
          </div>
        </div>
        <div class="match-status-swiper" v-else>
          <div class="item-box" :style="{width:status.length * 215 + 'px'}">
            <div class="item" v-for="item in status" :key="item.id" @click="ateToPage(item)">
              <div class="t1">
                <p>
                  <img :src="filterImage(item.homeTeam.badge,56,56)">
                  <i style="font-style: normal;" class="overflow-text">{{ item.homeTeam.name }}</i>
                </p>
                <span v-if="item.homeScore !== -1">{{ item.homeScore }}</span>
              </div>
              <div class="t1">
                <p>
                  <img :src="filterImage(item.awayTeam.badge,56,56)">
                  <i style="font-style: normal;" class="overflow-text">{{ item.awayTeam.name }}</i>
                </p>
                <span v-if="item.awayScore !== -1">{{ item.awayScore }}</span>
              </div>
              <div class="t2">
                <p :style="{color:item.color}">{{ item.liveStatus.statusLabel }}</p>
                <div>
                  <span>{{ filterDate(item.beginDate) }} </span>
                  <span>{{ item.roundDescription }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 乒乓球 羽毛起 领奖台 -->
      <div v-if="result && result.champion && (match.sportType == '乒乓球' || match.sportType == '羽毛球')">
        <div class="podium">
          <b>领奖台</b>
          <span>{{ match.gameType }}</span>
        </div>
        <div class="podium-item">
          <div class="item">
            <img :src="filterImage(result.champion.badge,60,60)" class="badge" />
            <div>
              <img src="@/assets/images/rankOne.png" class="img" />
            </div>
            <b>{{ result.champion.name }}</b>
          </div>
          <div class="item">
            <img :src="filterImage(result.secondPlace.badge, 60, 60)" class="badge" />
            <div>
              <img src="@/assets/images/rankingtwo.png" class="img" />
            </div>
            <b>{{ result.secondPlace.name }}</b>
          </div>
          <div class="item">
            <img :src="filterImage(result.thirdPlace.badge, 60, 60)" class="badge" />
            <div>
              <img src="@/assets/images/rankingThree.png" class="img" />
            </div>
            <b>{{ result.thirdPlace.name }}</b>
          </div>
        </div>
      </div>
      <!-- 篮球 足球 冠军球队 -->
      <div v-if="result && result.champion && (match.sportType != '乒乓球' && match.sportType != '羽毛球')">
        <div class="card bot" style="margin-top: 12px;">冠军球队</div>
        <div class="champion-list">
          <div class="left-img">
            <img :src="filterImage(result.champion.badge,120,120)" />
            <img src="@/assets/images/rankOne.png" class="no-1">
          </div>
          <div class="right">
            <p class="tr1">
              <span v-show="['足球', '篮球'].includes(match.sportType)">{{result.champion.name}} </span>
              <span v-show="match.sportType == '足球'"><span class="stats">进/失</span>{{result.champion.goalCount}} / {{result.champion.concededCount}}</span>
            </p>
            <div class="tr2">
              胜
              <div>
                <span :style="{width: result.champion.winRound / (result.champion.winRound *1 + result.champion.tieRound *1 + result.champion.loseRound *1) * 100 + '%'}"></span>
              </div>{{result.champion.winRound}}</div>
            <div class="tr2"  v-show="match.sportType == '足球'">
              平
              <div>
                <span :style="{width: result.champion.tieRound / (result.champion.winRound *1 + result.champion.tieRound *1 + result.champion.loseRound *1) * 100 + '%'}"></span>
              </div>{{result.champion.tieRound}}</div>
            <div class="tr2">
              负
              <div>
                <span :style="{width: result.champion.loseRound / (result.champion.winRound *1 + result.champion.tieRound *1 + result.champion.loseRound *1) * 100 + '%'}"></span>
              </div>{{result.champion.loseRound}}</div>
          </div>
        </div>
      </div>

      <!-- 足球 -->
      <FootballStats
        :match="match"
        :result="result"
        :data1="data1"
        :data2="data2"
        >
      </FootballStats>

      <!-- 篮球 -->
      <basketball
        :topPlayers="topPlayers"
        :match="match"
        :match-id="matchId"
      >
      </basketball>

      <!-- 橄榄球 -->
      <Rugby
        v-if="match.sportType === '橄榄球'"
        :teamList="teamList">
      </Rugby>

      <!-- 赛事资讯 -->
      <NewsList :newsList="newsList" :match="match" />
      <!-- 足球1 -->
      <FootballStats2 :data1="data1" :match="match"></FootballStats2>
      <!-- 视频 -->
      <VideoList :videoList="videoList" :match="match" />
      <!-- 球队数据 -->
      <div>
<!--        <div class="allowTeamSignup" v-if="match.allowTeamSignup === 1 && match.state == 0 && match.publicSignUp > 0">-->
<!--            <div>参赛球队</div>-->
<!--            <span @click="matchApply">赛事报名</span>-->
<!--        </div>-->
<!--        <div class="tab-fix" v-if="match.groupNames && match.groupNames.length > 1">-->
<!--          <div v-for="item in match.groupNames" :key="item.id" class="item">-->
<!--            <div :class="select === item.id ? 'select' : ''" @click="updateSelect(item.id)">{{ item.groupName || '其他' }}</div>-->
<!--            <div class="i"></div>-->
<!--          </div>-->
<!--        </div>-->
        <Team v-for="item in teamList" :key="item.id" :item="item" :matchId="matchId" :show-player-list="showPlayerList" />
      </div>

      <!-- 相关赛事 -->
      <div v-if="matchList.length > 0">
        <div class="related bot">
          <div class="item" v-for="item in matchList" :key="item.id" @click="goPages(item.id)">
            <img :src="filterImage(item.icon, 40, 40)">
            <div class="overflow-text">{{ item.chineseName }}</div>
            <van-icon name="arrow" color="#ababab" size="16" />
          </div>
        </div>
        <div class="more" @click="goPages()">更多相关赛事</div>
      </div>

      <!-- 赞助商 -->
      <div class="sponsor" v-if="sponsors.length>0">
        <div class="item" v-for="item in sponsors" :key="item.id">
          <div class="top">赛事赞助商:</div>
          <div class="box">
            <img :src="filterImage(item.logoImg,64,64)">
            <div>
              {{ item.title }}
              <br>
              <span>{{ item.content }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getBMMatchDetail, getBMMatchSponsorList } from '@/api/match'
import { QNImageUtil } from '@/utils'
import FootballStats from './components/FootballStats'
import FootballStats2 from './components/FootballStats2'
import Moment from 'moment'
import Basketball from './components/BasketballStats'
import Rugby from './components/RugbyStats'
import Team from './components/TeamList'
import NewsList from './components/NewsList'
import VideoList from './components/VideoList'
import { goNewVersionPage } from '@/utils/index'
export default {
  components: { FootballStats, FootballStats2, Basketball, Rugby, Team, NewsList, VideoList },
  name: 'MatchDetail',
  data() {
    return {
      matchId: null,
      match: {},
      result: {},
      status: [],
      data1: {},
      data2: {},
      newsList: [],
      videoList: [],
      teamList: [],
      teamList2: [],
      matchList: [],
      topPlayers: [],
      sponsors: [],
      championList:[],
      select: '',
      showPlayerList: 0,
      jetlympic: false
    }
  },
  created() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    this.matchId = this.$route.query.matchId
    this.getBMMatchDetail()
    this.getBMMatchSponsorList()
  },
  methods: {
    getBMMatchDetail() {
      getBMMatchDetail({ matchId: this.matchId }).then(res => {
        const data = res.data
        const unionMatch = res.data.unionMatch
        this.showPlayerList = unionMatch.showPlayerList
        if (data.roundGames) {
          this.status = data.roundGames.games.map(item => {
             if (item.liveStatus.status == -3 || item.liveStatus.status == 0 || (item.liveStatus.status == -1 && item.liveStatus.statusLabel == '即将直播')) {
              item.color = '#CF2F30';
              if (item.liveStatus.status == -3) {
                item.label = '即将直播';
              }
            } else if ((item.liveStatus.status == -1 && item.liveStatus.statusLabel == '比赛进行中') || item.liveStatus.status == 1) {
              item.color = '#CF2F30';
              if (item.liveStatus.status == 1) {
                item.label = '斑马直播中';
              }
            } else if (item.liveStatus.status == 2) {
              item.color = '#369AD4';
            }
            return item
          })
        }
        this.match = data.match
        const shareObj = {
          title: this.match.chineseName.split('_')[0] + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: this.match.chineseName.split('_')[1],
          image: QNImageUtil.imageView(this.match.icon),
          link: window.location.href
        }
        this.wxShare(shareObj)
        this.result = data.result || {}
        if (this.result.championsByGroups) {
          this.championList = this.result.championsByGroups;
        } else {
          this.championList.push(this.result.champion);
        }
        this.data1 = data.data1 || { avgMatchTeamGoalCount: 0 }
        this.data2 = data.data2 || { avgMatchTeamGoalCount: 0 }
        this.newsList = data.newsList
        this.videoList = data.videoList

        this.matchList = data.matchList
        this.topPlayers = data.topPlayers
        this.select = this.match.groupNames && this.match.groupNames[0] && this.match.groupNames[0].id
        if (this.match.groupNames.length > 1) {
          this.teamList2 = data.teamList
          // this.teamList = data.teamList.filter(res => {
          //   return res.groupId === this.select
          // })
        } else {
          // this.teamList = data.teamList
        }
        this.teamList = data.teamList
      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) {
        return '-敬请期待';
      } else if (currentTime >= startTime && currentTime <= endTime) {
        return '-激战正酣';
      } else {
        return '-完美闭幕';
      }
    },
    updateSelect(type) {
      this.select = type
      this.teamList = this.teamList2.filter(res => {
        return res.groupId === this.select
      })
    },
    getBMMatchSponsorList() {
      getBMMatchSponsorList({ matchId: this.matchId }).then(res => {
        this.sponsors = res.data.sponsors
      })
    },
    ateToPage(game) {
      if (game.liveStatus && (game.liveStatus.status === 1 || game.liveStatus.status === 2)) {
        goNewVersionPage({ path: 'gameSummary', gameId: game.id })
      } else {
        this.$router.push({ path: '/event/activity', query: { gameId: game.id }})
      }
    },
    filterDate(date) {
      return Moment(date).format('MM/DD')
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    goList(path) {
      this.$router.push({ path, query: { matchId: this.matchId }})
    },
    goMatchInfo() {
      this.$router.push({ path: 'info', query: { matchId: this.matchId }})
    },
    matchApply() {
      this.$router.push({ path:'/entry-page', query: { unionMatchId: this.matchId } })
    },
    goPages(id) {
      if (id) {
        this.$router.push({ path: '/match/home', query: { matchId: id } })
      } else {
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/related-matches?matchId=${this.matchId}`
        } else {
          window.location.href = `https://www.snsports.cn/webapp/main.html#/related-matches?matchId=${this.matchId}`
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
p{
  margin: 0;
}
.match-detail{
  background-color: #F8F8F8;
  .top{
    background-color: #fff;
    .bg-img{
      max-height: 210px;
      min-height: 160px;
      overflow: hidden;
      img{
        width: 100%;
      }
    }
    .nav-menu{
      padding: 8px 0;
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      justify-content: space-around;
      .item{
        text-align: center;
        img{
          width: 20px;
          height: 20px;
        }
        p{
          font-size: 12px;
          margin: 0;
        }
      }
    }
  }
  .match-status{
    margin-top: 10px;
    margin-bottom: 5px;
    .card{
      p{
        margin: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
          color: rgb(171, 171, 171);
          font-size: 12px;
        }
      }
    }
    .match-status-swiper{
      width: 100%;
      padding: 10px 0;
      background-color: #fff;
      overflow: hidden;
      overflow-x: auto !important;
      &::-webkit-scrollbar {
        display: none;
      }
      .item-box{
        display: flex;
        padding: 0 5px;
        .item{
          width: 215px;
          padding: 5px 10px;
          margin: 5px 2px;
          box-sizing: border-box;
          box-shadow: 0px 0px 3px 2px rgba($color: #000000, $alpha: 0.1);
          border-radius: 2px;
          .t1{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
            p{
              display: flex;
              align-items: center;
              font-size: 14px;
            }
            span{
              font-size: 18px;
            }
            img{
              width: 28px;
              height: 28px;
              margin-right: 5px;
            }
          }
          .t2{
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            div{
              color: #9B9B9B;
            }
          }
        }
      }
    }
  }
  .champion-list{
      padding: 10px 20px 10px 0;
      background-color: #fff;
      display: flex;
      align-items: center;
      .left-img{
        width: 106px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          width: 60px;
          height: 60px;
        }
        .no-1{
          width: 68px;
          height: 38px;
          margin-top: -13px;
        }
      }
      .right{
        border-left: 2px solid #f2f2f2;
        flex: 1;
        padding-left: 10px;
        .tr1{
          font-size: 16px;
          margin: 0;
          margin-bottom: 5px;
          .stats{
            font-size: 14px;
            margin: 0 10px 0 12px;
          }
        }
        & div:nth-child(2){
          span{
            background-color: #38906B;
          }
        }
        & div:nth-child(3){
          span{
            background-color: #0D7096;
          }
        }
        & div:nth-child(4){
          span{
            background-color: #CF2F30;
          }
        }
        .tr2{
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 5px;
          div{
            min-width: 85%;
            width: 85%;
            height: 6px;
            background-color: #F3F3F3;
            margin: 0 10px;
            span{
              width: 0;
              display: block;
              height: 100%;
              border-radius: 1px;
              transition: width 0.5s ease;
            }
          }
        }
      }
    }
  .organizer{
      width: 100%;
      text-align: right;
      color: #337ab7;
      min-height: 85px;
      font-size: 14px;
      padding-top: 10px;
  }
  .sponsor{
    background-color: #fff;
    margin-top: 10px;
    .item{
      padding: 0 20px;
      .top{
        font-size: 14px;
        color: #ababab;
      }
      .box{
        display: flex;
        padding: 10px 0;
        img{
          width: 64px;
          height: 64px;
          margin-right: 10px;
        }
        div{
          font-size: 14px;
          span{
            font-size: 12px;
            color: #ababab;
          }
        }
      }
    }
  }
}
.podium{
  background-color: #fff;
  padding: 10px 20px;
  display: flex;
  margin: 6px 0;
  box-sizing: border-box;
  margin-bottom: 2px;
  font-size: 16px;
  b{
    margin-right: 10px;
    font-weight: 400;
  }
  span{
    color: #ababab;
  }
}
.podium-item{
  display: flex;
  background-color: #fff;
  margin-bottom: 5px;
  .item{
    flex: 1;
    text-align: center;
    padding: 10px 0;
  }
  .badge{
    width: 60px;
    height: 60px;
  }
  .img{
    width: 60px;
    height: 38px;
    margin-top: -20px;
  }
  b{
    font-size: 14px;
    color: #464646;
    font-weight: 400;
    margin-top: -10px;
  }
}
.related{
  margin-top: 30px;
  background: #fff;
  .item{
    line-height: 56px;
    padding: 4px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img{
      width: 40px;
      height: 40px;
      margin-right: 6px;
    }
    div{
      font-size: 14px;
      flex: 1;
    }
  }
}
.card {
  background-color: #fff;
  font-size: 16px;
  padding: 12px 20px;
}
.bot{
  border-bottom: 2.5px solid #F8F8F8;
}
.more{
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  color: #ababab;
  background: #fff;
  margin-bottom: 20px;
}
.match-status-one{
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: #fff;
  padding: 10px 0;
  img{
    width: 52px;
    height: 52px;
    margin-bottom: 5px;
  }
  .team-class{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span{
      font-size: 12px;
    }
  }
  .vs{
    text-align: center;
    font-size: 12px;
    margin: 0 16px;
    .score{
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
}
.allowTeamSignup {
    margin-top: 10px;
    height: 50px;
    width: 100%;
    padding: 0 20px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f0;
    font-size: 16px;
    box-sizing: border-box;
    span {
      color: red;
      border-radius: 25px;
      display: inline-block;
      padding: 5px 10px;
      background-color: #EC4E4E;
      font-size: 12px;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
}

.tab-fix{
  display: flex;
  background-color: #fff;
  .item{
    position: relative;
    width: 50%;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    .select{
      color: #cc3232;
      border-bottom: 2px solid #cc3232;
    }
  }
  .i{
    position: absolute;
    top: 50%;
    right: 0;
    width: 1px;
    height: 30px;
    background-color: #f0f0f0;
    transform: translate(-50%,-50%);
  }
}
</style>
